export default __webpack_public_path__ + "static/media/21.30c17b07.gif";